import {mountOnId} from 'shared'
import {OverlayWidget} from 'widgets'

const config = betterplaceOverlayConfig.pop()
mountOnId(OverlayWidget, config.widgetId, config)
